var render = function render(){var _vm=this,_c=_vm._self._c;return _c('n-theme',{attrs:{"type":"driver"}},[_c('html-sheet',{ref:"sheet",attrs:{"title":_vm.$t('main.provide.boardPassengersSheet.title'),"video":_vm.$t('main.provide.boardPassengersSheet.video'),"content":_vm.$t('main.provide.boardPassengersSheet.content')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }